var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero is-dark"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"level"},_vm._l((_vm.contacts),function(c){return _c('div',{key:c,staticClass:"level-item is-size-3"},[_c('div',{domProps:{"innerHTML":_vm._s(c)}})])}))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-281c47fe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landing_contact.vue
// module id = 606
// module chunks = 0